import { render, staticRenderFns } from "./TempBereiche.vue?vue&type=template&id=2b4add68&scoped=true&"
import script from "./TempBereiche.vue?vue&type=script&lang=js&"
export * from "./TempBereiche.vue?vue&type=script&lang=js&"
import style0 from "./TempBereiche.vue?vue&type=style&index=0&id=2b4add68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4add68",
  null
  
)

export default component.exports